import React, { Component } from "react";

import ethnic_saree from "../assests/ethnic_saree.jpg";
import ladies_garments from "../assests/ladies_garments.jpg"
import fashion_accessories from "../assests/fashion_accessories.jpg";
import home_furnishing from "../assests/home_furnishing.jpg";
import custom_uniforms from "../assests/custom_uniforms.jpg";
import corporate_gifting from "../assests/corporate_gifting.jpg";


import "../styles/Services.css"; // Import the CSS file for the styles

export default class Services extends Component {
  render() {
    return (
      <div id="services">
        <section className="services-section py-5">
          <div className="container">
            {/* Section Heading */}
            <div className="text-center mb-5">
              <h1 className="fw-bold">Our Offerings</h1>
              <p className="text-muted">
                Explore our carefully curated range of fashion, lifestyle, and
                customized solutions tailored to elevate your personal and
                professional presence.
              </p>
            </div>

            {/* Services Grid */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
              {/* Ethnic Wear */}
              <div className="col">
                <div className="card h-100 text-center shadow-sm">
                  <img src={ethnic_saree} className="card-img-top" alt="Ethnic Wear" />
                  <div className="card-body">
                    <h5 className="card-title">
                      Ethnic Sarees & Dress Materials
                    </h5>
                    <p className="card-text">
                      Discover our exclusive collection of Jaipuri and Jodhpuri
                      prints, traditional sarees, and vibrant dress
                      materials—perfect for festivals, weddings, and everyday
                      elegance.
                    </p>
                  </div>
                </div>
              </div>

              {/* Ladies Wear */}
              <div className="col">
                <div className="card h-100 text-center shadow-sm">
                  <img src={ladies_garments} className="card-img-top" alt="Ladies Wear" />
                  <div className="card-body">
                    <h5 className="card-title">Ladies Garments</h5>
                    <p className="card-text">
                      From formal office wear to casual outfits and comfortable
                      nightwear, our range of ladies' garments is crafted to
                      complement every style and occasion.
                    </p>
                  </div>
                </div>
              </div>

              {/* Accessories */}
              <div className="col">
                <div className="card h-100 text-center shadow-sm">
                  <img
                    src={fashion_accessories}
                    className="card-img-top"
                    alt="Accessories"
                  />
                  <div className="card-body">
                    <h5 className="card-title">Fashion Accessories</h5>
                    <p className="card-text">
                      Elevate your look with our curated selection of ladies’
                      accessories—handbags, jewelry, and more. Every piece is
                      chosen to add a stylish edge to your ensemble.
                    </p>
                  </div>
                </div>
              </div>

              {/* Home Furnishing */}
              <div className="col">
                <div className="card h-100 text-center shadow-sm">
                  <img
                    src={home_furnishing}
                    className="card-img-top"
                    alt="Home Furnishing"
                  />
                  <div className="card-body">
                    <h5 className="card-title">Home Furnishing</h5>
                    <p className="card-text">
                      Add charm and comfort to your space with our home
                      furnishing range—cushions, curtains, and décor essentials
                      that merge utility with elegant design.
                    </p>
                  </div>
                </div>
              </div>

              {/* Corporate Uniforms */}
              <div className="col">
                <div className="card h-100 text-center shadow-sm">
                  <img
                    src={custom_uniforms}
                    className="card-img-top"
                    alt="Corporate Uniforms"
                  />
                  <div className="card-body">
                    <h5 className="card-title">Custom Uniforms</h5>
                    <p className="card-text">
                      Professionally designed uniforms for corporate offices,
                      hospitals, hotels, and schools. Tailored for comfort,
                      durability, and brand consistency.
                    </p>
                  </div>
                </div>
              </div>

              {/* Gifting Solutions */}
              <div className="col">
                <div className="card h-100 text-center shadow-sm">
                  <img
                    src={corporate_gifting}
                    className="card-img-top"
                    alt="Gifting"
                  />
                  <div className="card-body">
                    <h5 className="card-title">Customized Corporate Gifting</h5>
                    <p className="card-text">
                      Make an impression with thoughtful, personalized corporate
                      gifts. We design elegant solutions that reflect your brand
                      and build lasting connections.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
